// Import the functions you need from the SDKs you need
import { getApp, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBeZeN87uYyooRJykKxPFMYWIAVPcuZ7zc",
  authDomain: "bestie-bite.firebaseapp.com",
  projectId: "bestie-bite",
  storageBucket: "bestie-bite.appspot.com",
  messagingSenderId: "670792204883",
  appId: "1:670792204883:web:127d2611b06ec5092bfca6",
  measurementId: "G-FWCK8HNG3C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "bestie-bite-qr");

export const functions = getFunctions(getApp("bestie-bite-qr"), "europe-west1");
// connectFunctionsEmulator(functions, "127.0.0.1", 5001); // Uncomment this line to use the emulator
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
